import { 
	GET_PROJECT_COMMUNICATIONS_STATUSES, 
	GET_PROJECT_COMMUNICATIONS_STATUS,
	CREATE_PROJECT_COMMUNICATIONS_STATUS,
	UPDATE_PROJECT_COMMUNICATIONS_STATUS,
	DESTROY_PROJECT_COMMUNICATIONS_STATUS,
} from "./actions"

export function ProjectCommunicationsStatusesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_COMMUNICATIONS_STATUSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_COMMUNICATIONS_STATUS}_FULFILLED`:
		case `${CREATE_PROJECT_COMMUNICATIONS_STATUS}_FULFILLED`:
		case `${UPDATE_PROJECT_COMMUNICATIONS_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_COMMUNICATIONS_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectCommunicationsStatusesReducer } from "modules/project/communications/statuses/reducer"

// project_communications_statuses:ProjectCommunicationsStatusesReducer,
